module.exports = __webpack_public_path__ + "static/media/attachment.571e7f80.svg";